// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Traducciones planes - Español
 * @file plansTranslations.es.js
 */
export const plansTranslationsEs = {
  'plans.modal.title': 'Mejorar plan',
  'plans.modal.comparison_title': 'Comparación de planes',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.modal.free.line1': '30.000 caracteres por mes por cuenta.',
  'plans.modal.free.line2': 'Hasta 2 contactos por usuario.',
  'plans.modal.free.line3': 'Hasta 2 conversaciones activas por cuenta.',
  'plans.modal.free.line4': 'Sin archivos adjuntos ni espacio de almacenamiento.',
  'plans.modal.free.line5': 'Sin exportación de datos.',
  'plans.modal.free.line6': 'Historial de mensajes hasta 30 días.',
  'plans.modal.free.line7': '1 solo dispositivo por usuario.',
  'plans.modal.premium.line1': '300.000 caracteres por mes por cuenta.',
  'plans.modal.premium.line2': 'Hasta 100 contactos por usuario.',
  'plans.modal.premium.line3': 'Conversaciones y chats ilimitados (tenant).',
  'plans.modal.premium.line4': 'Hasta 50 MB de almacenamiento (tenant).',
  'plans.modal.premium.line5': 'Hasta 3 dispositivos por usuario.',
  'plans.modal.premium.line6': 'Invitaciones ilimitadas (tenant).',
  'plans.modal.premium.line7': 'Incluye exportación, traducción automática y archivos según límites del plan.',
  'plans.modal.premium_block_heading': 'Límites de uso del motor (premium)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Programa Founder',
  'plans.modal.foundation.categories_title': 'Categorías Founder ({slots} plazas)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'Posición 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'Los primeros en apoyar el proyecto. Máxima prioridad histórica.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'Posición 26–75',
  'plans.modal.foundation.cat_early_desc': 'Apoyo temprano con reconocimiento especial.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'Posición 76–150',
  'plans.modal.foundation.cat_std_desc': 'Cupo Founder dentro de las 150 plazas.',
  'plans.modal.foundation.advantages_title': 'Ventajas Founder',
  'plans.modal.foundation.adv1': 'Acceso al cupo Founder limitado ({slots} plazas con posición numerada).',
  'plans.modal.foundation.adv2': 'Reconocimiento como usuario fundador de ArChat.',
  'plans.modal.foundation.adv3': 'Insignia y presencia Founder en el ecosistema del producto.',
  'plans.modal.foundation.adv4': 'Prioridad histórica y estatus según tu posición (1–150).',
  'plans.modal.foundation.adv5': 'Beneficio permanente ligado a tu acceso Founder mientras aplique la política vigente.',
  'plans.modal.pro.tagline': 'Premium normal — sin componente Founder',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'Plan gratuito',
  'plans.free.price': '$0 / mes',
  'plans.free.features.contacts': 'Hasta 2 contactos por usuario',
  'plans.free.features.conversations': 'Hasta 2 conversaciones activas por cuenta',
  'plans.free.features.no_export': '30.000 caracteres/mes por cuenta; 34 mensajes/día y 1.000/mes; sin exportación',
  'plans.free.features.no_advanced': 'Sin archivos ni almacenamiento; historial 30 días; 1 dispositivo por usuario',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Plan Founder',
  'plans.foundation.price': '$15 / mes',
  'plans.foundation.features.contacts': 'Mismo contrato premium que PRO (hasta 100 contactos por usuario)',
  'plans.foundation.features.conversations': 'Conversaciones y chats ilimitados (tenant); mismos límites que PRO',
  'plans.foundation.features.badge': 'Programa Founder (150 plazas con posición numerada)',
  'plans.foundation.features.support': 'USD 15/mes mientras haya cupo Founder',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Plan Pro',
  'plans.pro.price': '$19 / mes',
  'plans.pro.features.contacts': 'Hasta 100 contactos por usuario',
  'plans.pro.features.conversations': 'Conversaciones y chats ilimitados (tenant); 1.667 msg/día, 50k/mes',
  'plans.pro.features.export': 'Hasta 50 MB (tenant); exportación, traducción automática y archivos según plan',
  'plans.pro.features.notifications': 'Hasta 3 dispositivos por usuario; invitaciones ilimitadas (tenant)',
  'plans.actions.free': 'Plan actual',
  'plans.actions.foundation': 'Quiero ser Founder',
  'plans.actions.pro': 'Mejorar a PRO',
  'plans.badges.recommended': 'RECOMENDADO',
  'plans.badges.limited': 'LIMITADO',
  'plans.badges.foundation': 'Founder',
  'plans.compare.title': 'Elige tu plan',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.free.price': '$0 / mes',
  'plans.compare.foundation.price': '$15 / mes',
  'plans.compare.pro.price': '$19 / mes',
  'plans.compare.foundation.badge': '150 cupos limitados',
  'plans.compare.cta.foundation': 'Convertirme en Founder',
  'plans.foundation.coming_soon.title': 'Próximamente disponible',
  'plans.foundation.coming_soon.message': 'Esta opción estará disponible próximamente en ArChat. Estamos trabajando para habilitarla en todos los países y plataformas de pago.',
  'plans.foundation.coming_soon.confirm': 'Aceptar',
  'plans.payments_disabled.title': 'Suscripciones',
  'plans.payments_disabled.message': 'Las suscripciones se están habilitando progresivamente. Podés ver los planes disponibles y sus beneficios.',
  'plans.payments_disabled.confirm': 'Aceptar',
  'plans.compare.cta.pro': 'Actualizar a PRO',
  'plans.compare.active': 'Plan actual',
  'plans.compare.limited': '',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.limit.title.messages': 'Límite de mensajes alcanzado',
  'plans.limit.message.messages': 'Has alcanzado el límite de mensajes de tu plan. Mejora a FOUNDATION o PRO para seguir enviando.',
  'plans.limit.title.storage': 'Límite de almacenamiento',
  'plans.limit.message.storage': 'Has alcanzado el límite de almacenamiento. Mejora tu plan para subir más archivos.',
  'plans.limit.title.invitations': 'Límite de invitaciones',
  'plans.limit.message.invitations': 'Has alcanzado el límite de invitaciones. Mejora tu plan para invitar a más contactos.',
  'plans.limit.reached': 'Límite alcanzado — Mejorar plan',
  'plans.founder.remaining': 'Quedan {count} cupos Founder',
  'plans.founder.remaining_last': 'Últimos {count} cupos Founder',
  'plans.founder.remaining_limited': 'Cupos limitados: quedan {count}',
  'plans.founder.remaining_very_low': 'Quedan solo {count} cupos Founder',
  'plans.founder.soldout': 'Founder agotado',
  'plans.compare.pro.adjustment_notice': 'El precio puede ajustarse según condiciones del servicio.',
  'plans.compare.institucional.price': 'Precio a medida',
  'plans.compare.institucional.title': 'Institucional',
  'plans.compare.yourPlan': 'Tu plan',
};
